import { SimboloDoPortal } from '@/components/marca/SimboloDoPortal';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * A MOLDURA DAS TELAS DE CONTA (24/10/2026, revisão do pesquisador): entrar, recuperar a senha, cadastro, solicitar acesso
 * e a troca da senha provisória — o mesmo cartão central com a marca, o título, e embaixo a volta para o login.
 *
 * Os campos e o botão de enviar de dentro ficam no padrão por esta moldura (borda leve, 48 px, o botão na largura toda),
 * sem reescrever cada formulário: são as regras `[&_…]` da classe abaixo. Caixa de marcar e botão de rádio ficam de fora.
 */
const PADRAO_DOS_CAMPOS = [
  '[&_input:not([type=checkbox]):not([type=radio])]:min-h-[48px]',
  '[&_input:not([type=checkbox]):not([type=radio])]:rounded-lg',
  '[&_input:not([type=checkbox]):not([type=radio])]:border',
  '[&_input:not([type=checkbox]):not([type=radio])]:border-gray-300',
  '[&_input:not([type=checkbox]):not([type=radio])]:px-3',
  '[&_select]:min-h-[48px] [&_select]:rounded-lg [&_select]:border-gray-300',
  '[&_textarea]:rounded-lg [&_textarea]:border-gray-300',
  '[&_button[type=submit]]:min-h-[48px] [&_button[type=submit]]:w-full [&_button[type=submit]]:rounded-lg [&_button[type=submit]]:font-semibold',
].join(' ');

export function CartaoDeConta({ titulo, subtitulo, children, rodape, voltarAoLogin = true, testId }: {
  titulo: ReactNode;
  subtitulo?: ReactNode;
  children: ReactNode;
  /** O que vai abaixo do cartão (outro caminho, um aviso). */
  rodape?: ReactNode;
  voltarAoLogin?: boolean;
  testId?: string;
}) {
  return (
    <div className="flex min-h-[calc(100vh-9rem)] items-start justify-center bg-fundo px-4 py-8 md:items-center md:py-12" data-testid={testId}>
      <div className="w-full max-w-md">
        <div className="mb-5 text-center">
          <p className="inline-flex items-center gap-2 whitespace-nowrap font-titulo text-xl font-bold text-marca"><SimboloDoPortal className="h-7 w-7 flex-shrink-0" />Portal Simulados</p>
          <p className="text-sm text-gray-600">Simulados com diagnóstico por habilidade — SAEB, BNCC e Enem — online, impresso ou sem internet</p>
        </div>
        <div className={`rounded-2xl border border-gray-200 bg-white p-5 shadow-sm md:p-8 ${PADRAO_DOS_CAMPOS}`}>
          <h1 className="font-titulo text-2xl font-bold text-tinta" data-testid="titulo-da-tela">{titulo}</h1>
          {subtitulo && <div className="mt-1 text-sm text-gray-600">{subtitulo}</div>}
          <div className="mt-4">{children}</div>
        </div>
        {rodape}
        {voltarAoLogin && (
          <p className="mt-5 text-center text-sm"><Link to="/login" className="inline-flex min-h-[44px] items-center text-marca-700 hover:underline">Voltar para entrar</Link></p>
        )}
      </div>
    </div>
  );
}
